import Vue from 'vue';
import Router from 'vue-router';
import {GlobalLoading} from '../utils';
import {vue} from "../main";


Vue.use(Router)

let options = {
    /**
     * best practice
     * 1. 定义 name，原因有 2
     *    1.1 因为 path 随时可能会变化，比如从 /channel 改为 /c
     *    1.2 监听路由的时候，通过 name 来判断路由的 to 和 from 变得异常的容易。
     *
     */
    routes: [
        // 备注，下面记录如何将首页地址 / 定位到 Channel Page
        // 1. 最开始使用的是 redirect to c，但是这样，首页地址就变成了 http://..../c，这种体验非常不好，试了下 forward，发现根本没有这个功能
        // 2. 于是，干脆直接将 index / 一样的映射到 Channel 上去得了。
        // { name: 'index', path: '/', component: () => import('../components/channel/Channel') },
        { name: 'index', path:'/', redirect: '/c/nature' },
        { name: 'channel', path: '/c/:code', component: () => import('../components/channel/Channel') },
        { name: 'profile', path: '/p/:code', component: () => import('../components/profile/Profile') },
        { name: 'entity', path: '/e/:shortcode', component: () => import('../components/entity/Entity') },
        { name: 'changePassword', path: '/u/cpw/:shortcode', component: () => import("../components/user/login/ResetPassword") }, // cpw -> change password
        { name: 'showAggrement', path: '/aggrement', component: () => import("../components/commons/ShowAggrement")},
        { name: 'listApps', path: '/listApps', component: () => import("../components/ListApps")},
        { name: 'pageNotFound', path: '/404', component: () => import("../components/commons/404") },
        // { name: 'imageviewer', path: '/imageviewer', component: () => import("../components/test/imageviewer") }, // @deprecated by using vue-awsome-swiper zoom feature.
        { path: '*', redirect: '/404' } // 如果访问了上述没有的组件，则直接跳转到 404
    ],
    // 参考路由的滚动行为 https://router.vuejs.org/zh/guide/advanced/scroll-behavior.html
    // 第三个参数 savedPosition 当且仅当通过浏览器的"前进/后退"按钮触发时（等价于调用 history back/forward）才可用。
    scrollBehavior (to, from, savedPosition){
        console.log(`scroll behavior, to ${to.name}, from ${from.name}`)
        let smoothToTop = {
            x: 0, y: 0,
            behavior: 'smooth'  // 这个 smooth 属性在手机端没有效果，是直接就定位到那了，没有 PC 端的滑动效果。
        }
        // 不设置 timeout 的话，在 chrome mobile 端跳转到 position 可能无效。
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if(to.name === 'entity'){ // 只要是 entity 都滑动到顶部，我发现如果返回 save position 的话，定位也不准确。
                    resolve(smoothToTop);
                }else{
                    if (savedPosition) {  // 表示是通过浏览器的前进后退触发（等价于调用 history back/forward）
                        resolve(savedPosition);
                    } else if (to.name === 'profile'){
                        resolve(smoothToTop);
                    } else {
                        resolve({}); // 返回一个空对象，则不发生滚动；注意文档中建议返回一个 Falsy 对象，注意千万别这么干，否则浏览器报错。
                    }
                }
            }, 300)
        })
    }
}
// 只有 hybrid app 需要 hash 模式，网页模式采用 history 更人性化
if (process.env.NODE_ENV !== 'hybridapp'){
    options.mode = 'history';
}

console.log('router mode ============> ', options.mode);

const router = new Router(options);

// 监听浏览器的回退/前进事件
window.popStateDetected = false
window.addEventListener('popstate', () => {
    window.popStateDetected = true
})

router.beforeEach((to, from, next) => {
    // 优化，如果是 history back 则没有必要做 loading，借鉴 scroll behavoir 的做法，通过监听 popstate 事件来实现
    let isHistoryBack = window.popStateDetected
    window.popStateDetected = false;
    console.log(`router before each, is history back action: ${isHistoryBack}`);
    if(!isHistoryBack){
        GlobalLoading.start();
    }
    next();
})

router.afterEach((to, from) => {
    GlobalLoading.stop();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js